var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c('TixMessage',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_c('p',[_vm._v("Logging in and redirecting…")])
}
var staticRenderFns = []

export { render, staticRenderFns }